<div class="row">
  <div class="col-12" id="settingsContainer">
    <div class="settings-window">
      <div class="upper-row">
        <span class="title">Change password</span>
      </div>
      <div class="settings-main">
        <div class="row">
          <div class="col-md-10 col-lg-8 col-xl-6">
            <app-change-password-form class="settings"></app-change-password-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
